import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IBanner } from '../commonModels/models'

export class GetPopupBannerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/popup-banner',
      requesterInfo,
    })
  }

  public async getBanner(id: number): Promise<IBanner> {
    this.props.url = `${this.props.url}/${id}`
    return await this.getAsync<IBanner>()
  }
}
